import * as Objects from '@core/objects';
import * as Search from '@app/models/search';
/**
 * These are some funciton utils to filter events in the logbook
 */
// search by term in: user doing the event and in event title
export function searchInLogbook(event: Objects.LogbookEvent, term: string): boolean {
    // Check if event is an object with a title property
    if (event.title && typeof event.title === 'string' && event.title.toLowerCase().includes(term.toLowerCase())) {
        return true; // Return true if the search term is found in the title property
    }
    if (event.hasOwnProperty('user') && event.user  
            && (event.user.name?.toLowerCase().includes(term.toLowerCase()) || event.user.email?.toLowerCase().includes(term.toLowerCase()) ) 
        ) {
        return true; // Return true if the search term is found in the user property
    }
    
    return false; // Return false if search term doesn't match
}

// filter by LogbookEvent title or user id int 
export function filterInLogbook(event: Objects.LogbookEvent, filters: Search.SearchAppliedFilter[]): boolean {
    let matchFilters = true;
    filters.forEach((filter: Search.SearchAppliedFilter) => {
        if( filter.key == 'user' && event.user.id != filter.item.id)
            matchFilters = false;
        if( filter.key == 'event' && event.title != filter.item.id)
            matchFilters = false;
    });
    return matchFilters;
}